import { useEffect } from 'react';
export var useOutSideClick = function (_a) {
    var getElements = _a.getElements, onClick = _a.onClick, _b = _a.isActive, isActive = _b === void 0 ? true : _b;
    useEffect(function () {
        var mouseDownListener = function (e) {
            if (getElements().some(function (i) {
                return i === null || i === void 0 ? void 0 : i.contains(e.target);
            })) {
                return;
            }
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        };
        if (typeof document !== 'undefined' && isActive) {
            document.addEventListener('mousedown', mouseDownListener, true);
        }
        return function () {
            document.removeEventListener('mousedown', mouseDownListener, true);
        };
    }, [isActive]);
};
//# sourceMappingURL=useOutSideClick.js.map